const LOAD_DATA_MASTER_INSTITUTIONS           = 'LOAD_DATA_MASTER_INSTITUTIONS'
const LOAD_DATA_MASTER_INSTITUTIONS_SUCCESS   = 'LOAD_DATA_MASTER_INSTITUTIONS_SUCCESS'
const LOAD_DATA_MASTER_INSTITUTIONS_FAILED    = 'LOAD_DATA_MASTER_INSTITUTIONS_FAILED'
const UNMOUNT_DATA_MASTER_INSTITUTIONS        = 'UNMOUNT_DATA_MASTER_INSTITUTIONS'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const masterInstitutionsReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_MASTER_INSTITUTIONS:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_MASTER_INSTITUTIONS_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_MASTER_INSTITUTIONS_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_MASTER_INSTITUTIONS:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default masterInstitutionsReducer;